import { createSelector } from 'reselect'

const getSettings = createSelector(
	[state => state.libraries],
	libraries => ({
		libraryUID: libraries.current.libraryUID,
		parentId: libraries.current.folderUID,
	})
)

export default getSettings
